/**
 * Full search-param shapes for deep-linked routes. TanStack Router types
 * `Link`'s `search` against the destination's `validateSearch` output, so
 * every key has to be present — these spread in the defaults.
 */

export const ORDERS_SEARCH_DEFAULTS = {
	page: undefined,
	status: undefined,
	region: undefined,
	dispute: undefined,
	riskLevel: undefined,
	shipping: undefined,
	needsAction: undefined,
	reviewStatus: undefined,
	minDaysInStatus: undefined,
	search: undefined,
	dateFrom: undefined,
	dateTo: undefined,
	sortBy: undefined,
	sortOrder: undefined,
} as const

export const REVIEW_APPEALS_SEARCH_DEFAULTS = {
	page: undefined,
	search: undefined,
	status: undefined,
	sort: undefined,
} as const

export const MONTHLY_CLOSES_SEARCH_DEFAULTS = {
	region: undefined,
	currency: undefined,
	year: undefined,
	status: undefined,
} as const

export const MODERATION_SEARCH_DEFAULTS = {
	page: undefined,
	search: undefined,
	pending: undefined,
	severity: undefined,
	status: undefined,
	tags: undefined,
	surface: undefined,
	userId: undefined,
	sort: undefined,
} as const

export const OFFERS_SEARCH_DEFAULTS = {
	page: undefined,
	status: undefined,
	awaiting: undefined,
	currency: undefined,
	voidReason: undefined,
	redeemed: undefined,
	minDaysWaiting: undefined,
	search: undefined,
	dateFrom: undefined,
	dateTo: undefined,
	sortBy: undefined,
	sortOrder: undefined,
} as const

export const TRANSACTIONS_SEARCH_DEFAULTS = {
	page: undefined,
	status: undefined,
	region: undefined,
	riskLevel: undefined,
	dispute: undefined,
	search: undefined,
	dateFrom: undefined,
	dateTo: undefined,
	sort: undefined,
} as const

export const USERS_SEARCH_DEFAULTS = {
	page: undefined,
	search: undefined,
	isSeller: undefined,
	accountStatus: undefined,
	sort: undefined,
} as const

export const COUPONS_SEARCH_DEFAULTS = {
	page: undefined,
	search: undefined,
	status: undefined,
	type: undefined,
	region: undefined,
	audience: undefined,
	source: undefined,
	programId: undefined,
} as const

export const COUPON_NEW_SEARCH_DEFAULTS = {
	from: undefined,
} as const

export const PRODUCTS_SEARCH_DEFAULTS = {
	gameSlug: undefined,
	expansionSlug: undefined,
	productType: undefined,
	finishes: undefined,
	rarity: undefined,
	productCategory: undefined,
	languages: undefined,
	q: undefined,
} as const

export const TASKS_SEARCH_DEFAULTS = {
	search: undefined,
	game: undefined,
	task: undefined,
} as const

export const EXPANSION_GROUPS_SEARCH_DEFAULTS = {
	gameSlug: undefined,
	create: undefined,
} as const

export const API_USAGE_SEARCH_DEFAULTS = {
	window: "24h",
	accessMode: "all",
	group: "account",
	stack: "accessMode",
	from: undefined,
	to: undefined,
	appId: undefined,
	accountId: undefined,
	endpoint: undefined,
	tag: undefined,
} as const
